import { Inject, Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { catchError, lastValueFrom, map } from "rxjs";
import { plainToInstance } from "class-transformer";
import { ErrorMessage } from "../models/errors";
import { Location, LocationInsert } from "../models/location";
import { ApiService } from "./api.service";
import { BASE_URL } from "./injection-tokens";
export class InvalidLocationError extends Error
{
    constructor(message: string)
    {
        super(message);
    }
}


export abstract class LocationServiceBase
{
    abstract addLocation(location: LocationInsert): Promise<Location>;
}



@Injectable({providedIn: 'root'})
export class LocationService extends LocationServiceBase
{

    constructor
    (
        private _api: ApiService,
        private _messages: MessageService,
        @Inject(BASE_URL) private _baseUri: string,

    )
    {
        super();
    }

    override addLocation(location: LocationInsert): Promise<Location> 
    {
        return lastValueFrom
        (
          this._api.makeAPIPutCall<Location>(this._baseUri,"/util/locations",location)
                  .pipe(map(location => plainToInstance(Location,location))
                  ,catchError
                  (
                    (error:ErrorMessage) =>  {throw new InvalidLocationError(error.message)}
                  ))
                  
        );

    }
    
}